import React from "react";
import LogoWithText from "../assets/images/logowithtext.png";

const UnderMaintenance = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#ffffff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "2rem",
        textAlign: "center",
      }}
    >
      <img
        src={LogoWithText}
        alt="Cutting Edge Academy"
        style={{ width: "220px", marginBottom: "2.5rem" }}
      />

      <div
        style={{
          width: "52px",
          height: "2px",
          backgroundColor: "#fb3104",
          marginBottom: "2.5rem",
        }}
      />

      <h1
        style={{
          fontSize: "1.6rem",
          fontWeight: 700,
          color: "#111111",
          marginBottom: "1.25rem",
          letterSpacing: "0.01em",
        }}
      >
        Website Under Maintenance
      </h1>

      <p
        style={{
          fontSize: "1rem",
          color: "#444444",
          lineHeight: 1.8,
          maxWidth: "540px",
          marginBottom: "0.75rem",
        }}
      >
        We are currently performing scheduled maintenance to enhance the quality
        and performance of our website. We sincerely apologize for any
        inconvenience this may cause.
      </p>

      <p
        style={{
          fontSize: "1rem",
          color: "#444444",
          lineHeight: 1.8,
          maxWidth: "540px",
          marginBottom: "2.5rem",
        }}
      >
        Our website will be back online shortly. Thank you for your patience and
        continued support.
      </p>

      <div
        style={{
          width: "52px",
          height: "2px",
          backgroundColor: "#fb3104",
          marginBottom: "2.5rem",
        }}
      />

      <p style={{ fontSize: "0.9rem", color: "#888888", marginBottom: "0.4rem" }}>
        For further inquiries, please contact us via
      </p>
      <a
        href="https://wa.me/628984001333"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          fontSize: "0.9rem",
          color: "#fb3104",
          textDecoration: "none",
          fontWeight: 600,
        }}
      >
        WhatsApp
      </a>

      <p
        style={{
          fontSize: "0.78rem",
          color: "#bbbbbb",
          marginTop: "3rem",
        }}
      >
        &copy; {new Date().getFullYear()} Cutting Edge Academy. All rights reserved.
      </p>
    </div>
  );
};

export default UnderMaintenance;
